import React from 'react';
import { useChat } from '../context/ChatContext';
import { useTranslation } from 'react-i18next';
import './Chat.css';

const NotificationWidget = () => {
    const { notifications, dismissNotification, openChat, unreadCount } = useChat();
    const { t } = useTranslation();

    const handleNotificationClick = (notification) => {
        openChat({
            jobId: notification.jobId,
            recipientName: t('support_team')
        });
        dismissNotification(notification.jobId);
    };

    if (notifications.length === 0) {
        return null;
    }

   return (
        <div className="notification-container">
            {notifications.map((notification, index) => {
                // DÜZELTME: Çeviri işlemi, artık render anında, burada yapılıyor.
                const translatedContent = t(notification.messageKey, notification.messageParams);

                return (
                    <div 
                        key={notification.jobId} 
                        className="notification-widget" 
                        style={{ bottom: `${20 + (index * 130)}px` }}
                        onClick={() => handleNotificationClick(notification)}
                    >
                        <div className="notification-header">
                            <i className="fas fa-comment-dots"></i>
                            <strong>{t('new_messages_count', { count: unreadCount })}</strong>
                            <button onClick={(e) => { e.stopPropagation(); dismissNotification(notification.jobId); }} className="dismiss-btn">&times;</button>
                        </div>
                        <div className="notification-body">
                            <p><strong>{notification.senderName}</strong> - #{notification.jobId}</p>
                            <p className="message-preview">{translatedContent}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default NotificationWidget;